import { DialogContent, withStyles } from '@material-ui/core';
import RoutePreview from './RoutePreview';
import DriverRecommendationsPanel from './DriverRecommendationsPanel';
import { useState, useRef } from 'react';

const styles = (theme) => ({
  dialogContent: {
    display: 'flex',
    justifyContent: 'space-between',
    overflow: 'hidden',
    padding: 0,
  },
});

const Content = ({ classes, ...others }) => {
  const [driverRoutePreviews, setDriverRoutePreviews] = useState({});
  const unassignedPickups = useRef([]);
  const mapConfiguration = useRef({ loading: true });

  const updateRoutePreview = ({ driverRoutePreview, unassignedPickups: pickups, mapConfig }) => {
    if (pickups) {
      unassignedPickups.current = pickups;
    }
    mapConfiguration.current = mapConfig;
    setDriverRoutePreviews(driverRoutePreview);
  };

  return (
    <DialogContent classes={{ root: classes.dialogContent }} className="customScroll">
      <RoutePreview
        {...others}
        driverRoutePreview={driverRoutePreviews}
        unassignedPickups={unassignedPickups.current}
        mapConfig={mapConfiguration.current}
      />
      <DriverRecommendationsPanel {...others} handleRoutePreview={updateRoutePreview} />
    </DialogContent>
  );
};

export default withStyles(styles)(Content);
